export default "__VITE_ASSET__DiHxZ$XH__"